import React from "react";
import injectSheet from "react-jss";

const styleSheet = () => ({
  yvLogo: {
    width: 158,
    height: 35,

    "& svg .logo_01_st1": {
      fill: "rgb(8, 0, 30)",
    },
    "& svg .logo_01_st2": {
      fill: "#00B5D1",
    },
    "& svg .logo_01_st0": {
      display: "none",
    },

    "& svg.yv-logo-svg": {
      width: "100%",
      height: "100%",
      enableBackground: "new 0 0 347.2 76",
    },
  },

  anchor: {
    display: "flex",
    justifyContent: "flex-end",
  },

  contactUS: {
    textDecoration: "underline",
  },
});

const YVLogo = ({ classes }) => (
  <div className={classes.yvLogo}>
    <svg
      className="yv-logo-svg"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="347.2px"
      height="76px"
      viewBox="0 0 347.2 76"
    >
      a
      <g>
        <path className="logo_01_st2" d="M160.2,8.2h3.8v59.6h-3.8V8.2z" />
        <g id="Layer_3" className="logo_01_st0" />
        <g id="Layer_2" className="logo_01_st0" />
        <g>
          <path className="logo_01_st1" d="M229.8,17.7h5.2v40.7h-5.2V17.7z" />
          <path
            className="logo_01_st1"
            d="M35.3,41.4v17h-5.2v-17L18.7,17.7h5.5l8.5,17.9l8.5-17.8h5.5L35.3,41.4z"
          />
          <path
            className="logo_01_st1"
            d="M111.1,46.3c0,6.2,2.8,7.9,8.8,7.9c6.1,0,8.7-1.6,8.7-7.9V17.7h5.2V46c0,8.9-4.9,13-14,13
			c-9,0-13.9-4.1-13.9-13V17.7h5.2V46.3z"
          />
          <path
            className="logo_01_st1"
            d="M303.3,17.7h26.3v5.2h-10.4v35.6H314V22.8h-10.7V17.7z"
          />
          <path
            className="logo_01_st1"
            d="M271.5,22.1c0,0-6.6-1-10.5-1c-5.4,0-7.4,1.9-7.4,6.8s2,5.7,8.1,7.3c7.3,1.8,11,4.1,11,11.3
			c0,8.2-3.9,12.5-12.2,12.5c-4.6,0-11.7-1.1-11.7-1.1l0.3-4.2c0,0,7.4,1.3,11.3,1.3c5.3,0,7.1-2.7,7.1-8c0-4.9-2.1-5.9-7.6-7.1
			c-7.5-1.8-11.5-4.6-11.6-11.5c-0.2-7.5,1.9-12.1,12.5-11.3c4.6,0.3,10.9,0.8,10.9,0.8L271.5,22.1z"
          />
          <path className="logo_01_st1" d="M286.8,17.7h5.2v40.7h-5.2V17.7z" />
          <path
            className="logo_01_st1"
            d="M216,17.6l-9.9,40.8h-7.2l-10-40.8h5.4l8.1,34.6h0.3l8-34.6H216z"
          />
          <path
            className="logo_01_st2"
            d="M74.8,17.4c9.6,0,15.7,1.3,18.5,5.9c1.4,2.2,2.1,5.1,2.1,9c0,12-6.3,14.9-20.6,14.9c-10,0-16.4-1.4-19.4-6.3
			c-1.3-2.1-1.9-4.9-1.9-8.5C53.5,20.3,60.4,17.4,74.8,17.4z M58.8,37.6c2.1,4.2,7,4.9,16,4.9c11.9,0,16.4-1.2,16.4-10.2
			c0-2.1-0.2-3.3-0.8-4.7c-1.4-3.6-6.5-5-15.6-5c-11.9,0-17,1.5-17,9.7C57.8,34.5,58,36.2,58.8,37.6z"
          />
          <g>
            <g>
              <path
                className="logo_01_st2"
                d="M56.4,53.3c0-0.5,0.3-0.9,0.9-0.9c0.5,0,1,0.3,1,0.8s-0.3,0.9-0.9,0.9C56.9,54.1,56.4,53.8,56.4,53.3z"
              />
            </g>
            <g>
              <path
                className="logo_01_st2"
                d="M86.1,55.7c-2.2,1.2-4.5,2.3-7.5,3c-3.3,0.8-8.5,0.6-9.8,0.4c-5.4-1-8.5-2.6-12.2-5.3
					c-0.5-0.4,0.5-1.5,1-1.3c2.4,1,8.8,3.3,15.5,2.9c1.9-0.1,4.7-0.3,5.8-0.5c3.4-0.4,5-0.6,6.4-0.9c0.4-0.1,0.4,0.2,0.6,0.3
					C86,54.3,86.6,55.3,86.1,55.7"
              />
              <g>
                <path
                  className="logo_01_st2"
                  d="M84.5,55c-0.1-0.5,0.4-0.9,0.9-1c0.6,0,1.1,0.3,1.1,0.8c0.1,0.5-0.4,0.9-0.9,1S84.6,55.5,84.5,55z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default injectSheet(styleSheet)(YVLogo);
